import { render, staticRenderFns } from "./OneAICFamily.vue?vue&type=template&id=137925aa&"
import script from "./OneAICFamily.vue?vue&type=script&lang=js&"
export * from "./OneAICFamily.vue?vue&type=script&lang=js&"
import style0 from "./OneAICFamily.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports